import { METHOD_POST } from 'requests/index';
import { SUB_FACILITIES } from 'constants/endpoints';
import { ApiRequestConfigType } from 'requests/index.types';

interface ISubFacilityAddressAttributes {
  name: string;
  address: string;
  unit_no: string;
  contact_name: string;
  contact_phone: string;
  contact_email: string;
  latitude: number;
  longitude: number;
  street: string;
  street_number: string;
  city: string;
  state: string;
  country: string;
}

export interface IByLinePatternPayload {
  sub_facility: {
    name: string;
    sub_facility_addresses_attributes: ISubFacilityAddressAttributes[];
  };
}

export const API_POST_b2bNewCustomer = (community_id: string, payload: IByLinePatternPayload) => {
  return {
    method: METHOD_POST,
    url: SUB_FACILITIES(community_id),
    __typename: 'LegacyAPI',
    body: payload,
  } as ApiRequestConfigType;
};
